/**
 * Central brand asset URLs.
 *
 * All logos / QR codes used across the app (UI headers, PDFs, print
 * templates) MUST reference this module — never hardcode a URL inline.
 * Assets are served from Cloudflare R2 (production-owned storage), so
 * they survive any future migration off the Emergent preview CDN.
 *
 * Override via env at build-time (REACT_APP_BRAND_*) when you rebrand
 * for a subsidiary or need a staging asset set.
 */

const R2_DEFAULT_PUBLIC =
    process.env.REACT_APP_R2_PUBLIC_URL ||
    'https://pub-391b3b7615324f2a876915def2e4b4cb.r2.dev';

export const BRAND_ASSETS = {
    /** Primary logo — small square mark used in headers, sidebars, print chrome. */
    LOGO_PRIMARY:
        process.env.REACT_APP_BRAND_LOGO_PRIMARY ||
        `${R2_DEFAULT_PUBLIC}/brand/logo-primary.jpg`,

    /** Wordmark logo — full "UNIVERS COSMETIC" lockup used on auth pages. */
    LOGO_WORDMARK:
        process.env.REACT_APP_BRAND_LOGO_WORDMARK ||
        `${R2_DEFAULT_PUBLIC}/brand/logo-wordmark.png`,

    /** Google-review QR code used in the letter/quotation footer. */
    REVIEW_QR:
        process.env.REACT_APP_BRAND_REVIEW_QR ||
        `${R2_DEFAULT_PUBLIC}/brand/review-qr.png`,
};
